module.exports = require('./helpers/bundle-url').getBundleURL('dj12v') + "binance.fd2a2cc4.svg";